// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"87ad6615","453":"0150742b","455":"ac3cd9d9","977":"2ab7719e"}[chunkId] + ".chunk.js";
};